import { Create } from 'react-admin'

import KidSeriesForm from './KidSeriesForm'

const KidSeriesCreate = props => (
  <Create redirect="list" {...props}>
    <KidSeriesForm />
  </Create>
)

export default KidSeriesCreate
